import { BlockCard } from "src/modules/worksheet/components/WorksheetEditor/components/Editor";

const renderCard = (props: any) => {
    return (
        <BlockCard {...props}>
            <div style={{ fontSize: "11px", fontWeight: "bold" }}>
                Figma Block
            </div>
        </BlockCard>
    );
};

export default renderCard;
